import { useStore } from '@tanstack/react-store'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import { AccessList } from './AccessList/AccessList'
import { AccessUpdate } from './AccessUpdate'

export const Access = () => {
  const match = useRouteMatch()

  return (
    <Switch>
      <Route path={`${match.url}/new`} exact>
        <AccessUpdate />
      </Route>
      <Route path={`${match.url}/edit/:id`} exact>
        <AccessUpdate />
      </Route>
      <Route path={`${match.url}`}>
        <AccessList />
      </Route>
    </Switch>
  )
}
